import React from 'react';

import './RestrictedContainer.scss';

interface IRestrictedContainerProps {
  className?: string;
  reference?: React.LegacyRef<HTMLDivElement>;
}

const RestrictedContainer: React.FC<IRestrictedContainerProps> = ({ children, className, reference: ref }) => {
  return (
    <div className={`restricted-container ${className ?? ''}`} ref={ref}>
      {children}
    </div>
  );
};

export default RestrictedContainer;
